
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.583.188H2.417C1.22.188.25 1.181.25 2.409v15.55c0 1.228.97 2.222 2.167 2.222H6.75L10 23.513l3.25-3.332h4.333c1.197 0 2.167-.994 2.167-2.222V2.41c0-1.227-.97-2.221-2.167-2.221zm-6.5 17.771H8.917v-2.221h2.166v2.221zm2.237-8.602l-.97 1.022c-.78.8-1.267 1.471-1.267 3.138H8.917v-.556c0-1.227.487-2.338 1.267-3.143l1.349-1.4c.39-.4.634-.955.634-1.566 0-1.227-.97-2.222-2.167-2.222-1.197 0-2.167.995-2.167 2.222H5.667c0-2.455 1.939-4.443 4.333-4.443s4.333 1.988 4.333 4.443a3.57 3.57 0 01-1.013 2.505z","fill":"#007185"}})])
          )
        }
      }
    